import type { GatDateEditEmits, GatDateEditProps } from '../gat-date-edit.vue'
import { isoDateTimeToZonedDateTimeWithAnchorTime } from './date-utils'
import type { ISODateTimeString } from '@gat-ship/types'
import { computed, nextTick, onMounted, ref, watch } from 'vue'

export function useDateInputModel(props: GatDateEditProps, emits?: GatDateEditEmits) {
  // The internal model value
  const _model = ref<ISODateTimeString | undefined>()

  /** The getter for model-value. Call updateModel to update it. */
  const modelValue = computed(() => _model.value)

  function getModelValue(
    value: ISODateTimeString | undefined,
    options?: {
      anchorTime?: 'midnight' | 'noon' | 'now'
      timeZone?: string
    }
  ) {
    if (!value) {
      return undefined
    }

    // Should only use anchorTime for date, not for datetime.
    const anchorTime =
      props.type === 'datetime' ? undefined : (options?.anchorTime ?? props.anchorTime)
    const date = isoDateTimeToZonedDateTimeWithAnchorTime(value, {
      anchorTime,
      timeZone: options?.timeZone ?? props.timeZone
    })
    return date.toInstant().toString() as ISODateTimeString
  }

  /** Call this function to update the model value. */
  function updateModel(
    value: ISODateTimeString | undefined,
    options?: {
      anchorTime?: 'midnight' | 'noon' | 'now'
      timeZone?: string
    }
  ) {
    console.log('updateModel', value)
    const newModelValue = getModelValue(value, options)
    if (newModelValue !== _model.value) {
      _model.value = newModelValue
      if (emits) {
        emits('update:modelValue', newModelValue)
      }
    }
  }

  watch(
    () => props.modelValue,
    (newModelValue) => {
      updateModel(newModelValue)
    }
  )

  onMounted(() => {
    _model.value = props.modelValue
  })

  return { model: modelValue, updateModel }
}
